import { Component, inject, input, output, signal } from '@angular/core';

import type { MenuLI } from '../../../../types/menu-li';

import { Environment } from '../../../../../environments/environment';
import { StateService } from '../../../../services/state/state';
import { SideMenu } from './side-menu/side-menu';

@Component({
  imports: [SideMenu],
  selector: 'app-mobile',
  templateUrl: './mobile.html',
})
export class Mobile {
  private readonly _stateService = inject(StateService);

  public readonly authIconClicked = output();
  public readonly menuItems = input.required<MenuLI[]>();
  public readonly temperature = input.required<number>();

  protected readonly showMenu = signal(false);

  public handleAuthClicked(): void {
    if (!this._stateService.userToken()) {
      this._stateService.handleAuthRequest();
    } else {
      //navigate to myvillages or postmessage for nav
    }
  }

  public openMyVillages(): void {
    // if (environment.isApp){
    //   this.stateService.notifyParentOfStateChange('HF_EVENT:MY_VILLAGES_CLICKED');
    // }
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _url = `${_origin}/myvillages/`;

    const _newWindow = window.open(_url, '_blank');
    if (_newWindow) {
      _newWindow.opener = null; // Add this line to prevent the new window from having access to the opener's context for security reasons
    }
  }
}
